import { useEffect, useState } from 'react';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Scroll back to top"
      title="Back to top"
      className={`fixed z-40 right-4 md:right-6 bottom-[calc(1rem+env(safe-area-inset-bottom))] md:bottom-[calc(2.5rem+env(safe-area-inset-bottom))] touch-manipulation transition-opacity duration-300 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background-50 ${
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      <span className="float-soft flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500 text-background-50 border border-background-50/30 hover:bg-primary-600 active:scale-95 transition-transform">
        <i className="ri-arrow-up-line text-lg md:text-xl"></i>
      </span>
    </button>
  );
}